import "../analysis/styles/Analysis.css"
import { useNavigate } from "react-router-dom"
import React, { useEffect, useState } from "react"
import AnalysisTopSongs from "../analysis/top-songs/AnalysisTopSongs"
import { RootState } from "../../../store"
import { connect } from "react-redux"
import { fetchAllSummaries, fetchTopSongDateOptions } from "../../../actions/analysisActions"
import { TrendTrack, User } from "../../../types"
import { KSpan } from "kahuna-base-react-components"
import { PERMISSIONS, USER_ROLE } from "../../../constants"
import { lang } from "../../../constants/languages"
import { HoveredIndex, PlatformsLineChartComponent } from "../trends/streams-daily/StreamsDaily"
import { trends } from "../../../apis"

const Overview = ({
  fetchAllSummaries,
  fetchTopSongDateOptions,
  newReleasePermission,
  user
}: {
  fetchAllSummaries: (
    dateKey: string,
    type: string,
    value: string | number,
    affiliate: boolean,
    startDate?: string,
    endDate?: string
  ) => Promise<void>
  fetchTopSongDateOptions: () => Promise<void>
  newReleasePermission: boolean
  user: User
}) => {
  const [loading, setLoading] = useState(true)
  const [streamsDaily, setStreamsDaily] = useState([])
  const [hoveredIndex, setHoveredIndex] = useState<HoveredIndex>({
    datasetIndex: -1,
    dataIndex: -1
  })

  const monthRange = 12
  const defaultStartDate = new Date(new Date().getFullYear(), new Date().getMonth() - (monthRange - 1))
  const defaultEndDate = new Date()

  const navigate = useNavigate()

  const getDatesAndAllSummaries = async () => {
    setLoading(true)
    const startDateYear = defaultStartDate.getFullYear()
    const startDateMonth = String(defaultStartDate.getMonth() + 1).padStart(2, "0")
    const endDateYear = defaultEndDate.getFullYear()
    const endDateMonth = String(defaultEndDate.getMonth() + 1).padStart(2, "0")
    const startDateParam = `${startDateYear}${startDateMonth}`
    const endDateParam = `${endDateYear}${endDateMonth}`
    try {
      await fetchTopSongDateOptions()
      await fetchAllSummaries("approved_date", "platform", "all_platforms", false, startDateParam, endDateParam)
    } finally {
      setLoading(false)
    }
  }

  const getStreamsDailyTopTracks = () => {
    trends(`/streams_last_7_days/`, "get")
      .then((resp) => {
        if (resp.data.results) {
          let streamsDaily = resp.data.results
          if (streamsDaily.length >= 5) {
            const isrcList = streamsDaily.slice(0, 5).map((streamDaily: TrendTrack) => streamDaily.isrc)
            streamsDaily = streamsDaily.filter((streamsDaily: TrendTrack) => isrcList.includes(streamsDaily.isrc))
          }
          setStreamsDaily(streamsDaily)
        }
      })
      .catch(() => {})
  }

  useEffect(() => {
    getDatesAndAllSummaries().then(() => {})
    getStreamsDailyTopTracks()
  }, [])

  const renderFirstQuickLink = () => {
    return newReleasePermission ? (
      <div className="quick-access-div" onClick={() => navigate(`/catalog/new-release`)} data-testid="new-release-card">
        <img src="/navigation_icons/music.svg" className="quick-access-img" />
        <div className="mt-5">
          <KSpan text={lang.overview.new_release_header} color="#000" fontSize={16} fontWeight={500} />
        </div>
        <div className="mt-3">
          <KSpan text={lang.overview.new_release_desc} />
        </div>
      </div>
    ) : (
      <div className="quick-access-div" onClick={() => navigate("/account/profile")}>
        <img src="/navigation_icons/profile_dropdownmenu_icons/user-filled.svg" className="quick-access-img" />
        <div className="mt-5">
          <KSpan text={lang.overview.profile_header || "Profile"} color="#000" fontSize={16} fontWeight={500} />
        </div>
        <div className="mt-3">
          <KSpan
            text={lang.overview.profile_desc || "Let's go to the profile page and make sure everything is up to date."}
          />
        </div>
      </div>
    )
  }

  const renderThirdQuickLink = () => {
    return user.role?.id === USER_ROLE.Affiliate ? (
      <div className="quick-access-div" onClick={() => navigate("/affiliate")}>
        <div className="flex justify-between items-center">
          <img src="/navigation_icons/affiliate.svg" className="quick-access-img" />
        </div>
        <div className="mt-5">
          <KSpan text={lang.overview.affiliate_header} color="#000" fontSize={16} fontWeight={500} />
        </div>
        <div className="mt-3">
          <KSpan text={lang.overview.affiliate_desc} />
        </div>
      </div>
    ) : (
      <div className="quick-access-div" onClick={() => navigate("/artist-space")}>
        <div className="flex justify-between items-center">
          <img src="/navigation_icons/earth.svg" className="quick-access-img" />
        </div>
        <div className="mt-5">
          <KSpan text={lang.overview.artist_space_header} color="#000" fontSize={16} fontWeight={500} />
        </div>
        <div className="mt-3">
          <KSpan text={lang.overview.artist_space_desc} />
        </div>
      </div>
    )
  }

  return (
    <div>
      {streamsDaily.length > 0 && (
        <div className="grid gap-4">
          <KSpan text={lang.overview.top_5_tracks} fontSize={18} fontWeight={500} color="#111" />
          <div className="flex-grow min-h-0 w-full" style={{ height: 300 }}>
            <PlatformsLineChartComponent data={streamsDaily} hoveredIndex={hoveredIndex} setHoveredIndex={() => {}} />
          </div>
        </div>
      )}
      {/*!loading && (
        <div className="flex flex-col justify-start gap-4">
          <div className="mt-6 gap-4  rounded-[10px] pb-6">
            {
              <AnalysisChart
                dateKey={"approved_date"}
                initialData={allSummaries}
                monthRange={monthRange}
                defaultStartDate={defaultStartDate}
                defaultEndDate={defaultEndDate}
              />
            }
          </div>
        </div>
      )*/}
      <div className="mt-3">
        <div className="pl-4">
          <KSpan text={lang.overview.title} fontSize={18} fontWeight={500} color="#111" />
        </div>
        <div
          className="flex mt-4 p-2"
          style={{
            width: "100%",
            borderRadius: 10,
            border: "1px solid var(--stroke-soft-200, #F3F3F3)",
            background: "var(--bg-white-0, #FFF)",
            boxShadow: "0px 2px 4px 0px rgba(27, 28, 29, 0.04)"
          }}
        >
          {renderFirstQuickLink()}
          <div className="mt-2 mb-2" style={{ borderRight: "1px solid #f7f7f7" }} />
          <div className="quick-access-div" onClick={() => navigate("/royalties")}>
            <div className="flex justify-between items-center">
              <img src="/navigation_icons/presentation-chart.svg" className="quick-access-img" />
            </div>
            <div className="mt-5">
              <KSpan text={lang.overview.royalties_header} color="#000" fontSize={16} fontWeight={500} />
            </div>
            <div className="mt-3">
              <KSpan text={lang.overview.royalties_desc} />
            </div>
          </div>
          <div className="mt-2 mb-2" style={{ borderRight: "1px solid #f7f7f7" }} />
          {renderThirdQuickLink()}
        </div>
      </div>
      <AnalysisTopSongs />
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    totals: state.analysis.totals,
    currency: state.auth.user.preferredCurrency,
    user: state.auth.user,
    selectedDate: state.analysis.selectedDate,
    selectedFilter: state.analysis.selectedFilter,
    summaries: state.analysis.summaries,
    filterOptions: state.analysis.filterOptions,
    allSummaries: state.analysis.allSummaries,
    newReleasePermission: state.auth.user.permissionUser?.some((item) => {
      return item.permission && item.permission.id === PERMISSIONS.NewRelease
    })
  }
}

export default connect(mapStateToProps, { fetchAllSummaries, fetchTopSongDateOptions })(Overview)
